import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import market from './modules/market'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    market
  }
});
export default store